export const faqQuestion=(id)=>`/v2/guest/faqs/${id}`;
export const faq_categories=`/v2/guest/faq-categories`;
export const filterQuestion=`/v2/guest/faq-by-questions`;
